<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_service_request") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #000">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Service Main Data ==== -->
      <form @submit.prevent="submitForm">
        <div class="row">
          <h6 class="col-12 mb-3">{{ $t("PLACEHOLDERS.providerInfo") }}</h6>

          <!-- Start:: Provider Name Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.provider_name')"
            v-model.trim="data.provider_name"
            disabled
          />
          <!-- End:: Provider Name Input -->

          <!-- Start:: Provider Type Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.office_type')"
            v-model.trim="data.provider_type"
            disabled
          />
          <!-- End:: Provider Type Input -->

          <!-- Start:: Provider Phone Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.provider_phone"
            disabled
          />
          <!-- End:: Provider Phone Input -->

          <h6 class="col-12 mb-3 mt-4">{{ $t("PLACEHOLDERS.serviceInfo") }}</h6>

          <!-- Start:: Service Name Arabic Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_ar')"
            v-model.trim="data.service_name_ar"
            disabled
          />
          <!-- End:: Service Name Arabic Input -->

          <!-- Start:: Service Name English Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.service_name_en')"
            v-model.trim="data.service_name_en"
            disabled
          />
          <!-- End:: Service Name English Input -->

          <!-- Start:: Current Price Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.current_price')"
            v-model.trim="data.current_price_display"
            required
          />
          <!-- End:: Current Price Input -->

          <!-- Start:: Status Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.status')"
            v-model.trim="data.status_display"
            disabled
          />
          <!-- End:: Status Input -->

          <!-- Start:: Creation Date Input -->
          <base-input
            col="4"
            type="text"
            :placeholder="$t('PLACEHOLDERS.created_at')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Creation Date Input -->
        </div>

        <!-- Start:: Submit Button -->
        <div class="btn_wrapper col-12">
          <base-button
            class="mt-4"
            styleType="primary_btn"
            :btnText="$t('BUTTONS.save')"
            :isLoading="isWaitingRequest"
            :disabled="isWaitingRequest"
          />
        </div>
        <!-- End:: Submit Button -->
      </form>
      <!-- ==== End:: Service Main Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "EditServiceManagement",
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        provider_name: null,
        provider_type: null,
        provider_phone: null,
        service_name_ar: null,
        service_name_en: null,
        current_price_display: null,
        status_display: null,
        status: null,
        created_at: null,
        rejection_reason: null,
      },
      // End:: Data

      // Start:: Form Data
      form: {
        price: null,
        currency: null,
      },
      errors: {},
      // End:: Form Data

      // Start:: Currencies List
      currencies: [
        {
          id: 1,
          name: "SAR - ريال سعودي",
          value: "SAR",
        },
        {
          id: 2,
          name: "USD - دولار أمريكي",
          value: "USD",
        },
        {
          id: 3,
          name: "EUR - يورو",
          value: "EUR",
        },
      ],
      // End:: Currencies List
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      this.isWaitingRequest = true;
      try {
        let res = await this.$axios({
          method: "GET",
          url: `additional-services/${this.$route.params.id}`,
        });

        const serviceData = res.data.data.AdditionalService;

        this.data = {
          provider_name: serviceData.provider?.name || null,
          provider_type: serviceData.provider?.exhibitor_type_trans || null,
          provider_phone: serviceData.provider?.mobile || null,
          service_name_ar: serviceData.name_ar || serviceData.name || null,
          service_name_en: serviceData.name_en || null,
          current_price_display: serviceData.price,
          status_display:
            serviceData.status_trans || this.getStatusText(serviceData.status),
          status: serviceData.status,
          created_at: serviceData.created_at || null,
          rejection_reason: serviceData.rejection_reason || null,
        };

        // Pre-fill form with current data
        this.form.price = serviceData.price;
        this.form.currency =
          this.currencies.find((c) => c.value === serviceData.currency) ||
          this.currencies[0];

        this.isWaitingRequest = false;
      } catch (error) {
        this.isWaitingRequest = false;
        console.log(error.response.data.message);
        this.$router.push({ path: "/servicesmanagement/all" });
      }
    },

    // Start:: Status Methods
    getStatusColor(status) {
      switch (status) {
        case "pending_review":
          return "orange";
        case "accepted":
          return "green";
        case "rejected":
          return "red";
        default:
          return "grey";
      }
    },

    getStatusText(status) {
      switch (status) {
        case "pending_review":
          return this.$t("PLACEHOLDERS.pending");
        case "accepted":
          return this.$t("PLACEHOLDERS.accepted");
        case "rejected":
          return this.$t("PLACEHOLDERS.rejected");
        default:
          return this.$t("PLACEHOLDERS.unknown");
      }
    },

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;
      this.errors = {};

      try {
        await this.$axios({
          method: "POST",
          url: `additional-services/${this.$route.params.id}/update-price`,
          data: {
            price: this.data.current_price_display,
          },
        });

        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.updatedSuccessfully"));
        this.$router.push({
          path: `/servicesmanagement/all`,
        });
      } catch (error) {
        this.isWaitingRequest = false;
        if (error.response?.data?.errors) {
          this.errors = error.response.data.errors;
        }
        this.$message.error(
          error.response?.data?.message || this.$t("MESSAGES.errorOccurred")
        );
      }
    },

    // Start:: Go Back
    goBack() {
      this.$router.push({
        path: `/servicesmanagement/show/${this.$route.params.id}`,
      });
    },
  },

  created() {
    this.getDataToShow();
  },
};
</script>

<style scoped>
.single_step_form_content_wrapper {
  padding: 20px;
}

.form_title_wrapper {
  margin-bottom: 20px;
}

.form_title_wrapper h4 {
  color: #333;
  font-weight: 600;
}

.btns_wrapper {
  display: flex;
  gap: 15px;
  justify-content: flex-start;
  margin-top: 30px;
}

.submit_btn {
  background-color: #28a745;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s;
}

.submit_btn:hover {
  background-color: #218838;
}

.submit_btn:disabled {
  background-color: #6c757d;
  cursor: not-allowed;
}

.cancel_btn {
  background-color: #6c757d;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.3s;
}

.cancel_btn:hover {
  background-color: #5a6268;
}
</style>
